import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../../../config/config';
import { Button, Breadcrumb } from 'semantic-ui-react'

import { NodeLinkGraph } from '../../../../components/productpage_wip/data-viz/NodeLinkGraph';
import { Link } from 'react-router-dom'
import { replaceSpaceInName } from '../../../../common/helperMethods';
import default_image from '../../../../assets/images/add-event-default.png'
import SvgIcon from '../../../common/svg-icon/svg-icon'

import { number_formatter } from '../../../../common/helperMethods';

const IndustryValueChain = (props) => {
   const history = useHistory();
   const [activeTab, setActiveTab] = useState('Technologies');
   const [technology1slideData, setTechnology1slideData] = useState([]);

   const [clientsSlideData, setclientsSlideData] = useState([]);

   const [IndustriesData, setIndustriesData] = useState([]);

   const [applications, setapplications] = useState([]);
   const [prod_info, setprod_info] = useState([]);
   const [applicationsCount, setapplicationsCount] = useState(0);
   const [default_industry, setdefault_industry] = useState('')

   const handleTabClick = (tab) => {
      setActiveTab(tab);
   };

   useEffect(() => {
      console.log('props ', props )
      if (props != undefined && props.curentProd != undefined) {
         
          axios.get(`${BASE_URL}/api/v2/industry/${props.curentProd.product.id}/suppliers`, {
            "from": 0,
            "size": 10
         }).then((response) => {
            const { data } = response.data
             if (data.rows.length > 0) {
               setclientsSlideData(data.rows)
            }

         }).finally(() => {
            //  setLoading(false)
         })

         axios.get(`${BASE_URL}/api/v2/industry/${props.curentProd.product.id}/products`, {
            "from": 0,
            "size": 16
         }).then((response) => {
            const { data } = response.data
            if (data.rows.length > 0) {
               setTechnology1slideData(data.rows)
            }


         }).finally(() => {
            //  setLoading(false)
         })
      }

      if (props.curentProd != undefined) {
         if (localStorage.getItem('industry_data') != 'undefined' || localStorage.getItem('industry_data') != undefined) {
            setdefault_industry(props.curentProd)
            setTimeout(() => {
               getProduct(props.curentProd)
            }, 1500);
         }
      }
   }, [props.curentProd])

   const getProduct = (item) => {
      if (item.product != undefined && item.product.id != undefined) {
         /*   history.push(`/product/${replaceSpaceInName(item.name)}/${item.id}`); */
         setapplications([])
         setprod_info([])
         setapplicationsCount(0)

         axios.get(`${BASE_URL}/api/v1/product/${item.product.id}?value_chain=true`, {
            "from": 0,
            "size": 10
         }).then((response) => {
            const { Item } = response.data
            console.log('product ', Item)
            setprod_info(Item)

            axios.get(`${BASE_URL}/api/v1/product/application/${item.product.id}`, {
               "from": 0,
               "size": 30
            }).then((response) => {
               const { Items, Count } = response.data
               setapplications(Items)
               setapplicationsCount(Count)

            }).finally(() => {
               //  setLoading(false)
            })

         }).finally(() => {
            //  setLoading(false)
         })
      }
   }

   const gotoCompany = (item) => {
      if (item.name != undefined && item.id != undefined) {

         history.push(`/company/${replaceSpaceInName(item.name)}/${item.id}`);
      }
   }

   const gotoProduct = (item) => {
      if (item.name != undefined && item.id != undefined) {
         history.push(`/product/${replaceSpaceInName(item.name)}/${item.id}`);
      }
   }
   
   const gotoRequestQuote = (item) => {
      if (item.name != undefined && item.id != undefined) {
         history.push(`/request-quote/product/${item.id}`);
      }
   }

   const render_image = (item) => {
      const { original_images } = item || {};
      if (original_images && original_images.length > 0) {
         return (
            <Link to={`/product/${replaceSpaceInName(item.name)}/${item.id}`}><img src={original_images[0]['value']} alt='' /></Link>

         )
      } else {
         return (
            <Link to={`/product/${replaceSpaceInName(item.name)}/${item.id}`}><img src={default_image} alt='' /></Link>
         )
      }
   }

   const render_partner_image = (item) => {
      if (item.logo) {
         return (
            <Button onClick={() => gotoCompany(item)}> <img src={item.logo} alt='' /></Button>
         )
      } else {
         return (
            <Button onClick={() => gotoCompany(item)}><img src={default_image} alt='' /></Button>
         )

      }
   }

   const render_products = (listdata) => {
      return (
         <section className='technologies-section'>
            <h1 className='main-heading text-left'><span>Technologies </span> that you may want to explore</h1>
            <div className='technologies-row'>
               {listdata.map(item => (
                  <div key={item.id} className='technologies-card'>
                     <div className='card-upper'>
                        {render_image(item)}
                     </div>
                     <div className='card-bottom'>
                        <div className='event-name'>
                           <Link to={`/product/${replaceSpaceInName(item.name)}/${item.id}`} >{item.name}</Link>
                           <ul>
                              {/* <li>{item.followers} <SvgIcon name='staricon' viewbox="0 0 14 13" /></li> */}
                              {item.view_count != undefined && item.view_count != 0 && <li> {number_formatter(item.view_count)} <SvgIcon name='eye-icon' viewbox="0 0 10 7" /></li>}
                           </ul>
                        </div>
                        <div className='info-list'>
                           <div className='list-item'>{number_formatter(item.supplier_count)} &nbsp; Suppliers &nbsp; | &nbsp; {number_formatter(item.application_count)} &nbsp; Applications &nbsp; | &nbsp; {number_formatter(item.raw_material_count)} &nbsp; Materials</div>
                        </div>
                     </div>
                     <div className='card-action'>
                        <Button onClick={() => gotoProduct(item)}>Explore </Button>
                        <Button onClick={() => gotoRequestQuote(item)}>Request Quote</Button>
                     </div>
                  </div>
               ))}
            </div>
         </section>
      )
   }


   return (
      <>
         <ul className='nav-tabs'>
            <li className={activeTab === 'Technologies' ? 'active' : ''} onClick={() => handleTabClick('Technologies')}>
               Technologies
            </li>
            <li className={activeTab === 'Suppliers' ? 'active' : ''} onClick={() => handleTabClick('Suppliers')}>
               Suppliers
            </li>
            <li className={activeTab === 'ValueChain' ? 'active' : ''} onClick={() => handleTabClick('ValueChain')}>
               Value Chain
            </li>
         </ul>
         {activeTab === 'Technologies' &&
            <>
               {technology1slideData.length > 0 && render_products(technology1slideData)}
            </>
         }
         {activeTab === 'Suppliers' &&
            <>
               <div className='ourpartner-row'>
                  {clientsSlideData.length > 0 && clientsSlideData.map((item) => (
                     <div className="ourpartner-card" key={item.id}>
                        <div className="card-upper">{render_partner_image(item)}</div>

                        <div className="card-bottom">
                           <div className="event-name">
                              <Link to={`/company/${replaceSpaceInName(item.name)}/${item.id}`}> {item.name}</Link>
                              <ul>
                                 {/* Uncomment to show stars if needed
                                <li>
                                  {item.view_count} <SvgIcon name="staricon" viewbox="0 0 14 13" />
                                </li>
                                */}
                                 {item.view_count != undefined && item.view_count != 0 && <li> {number_formatter(item.view_count)} <SvgIcon name='eye-icon' viewbox="0 0 10 7" /> </li>}
                              </ul>
                           </div>

                           <div className='info-list'>
                              <div className='list-item'>{number_formatter(item.product_count)} &nbsp; Technologies &nbsp; | &nbsp; {/*{number_formatter(item.mapping)} Applications  |*/}  {number_formatter(item.employee_count)} &nbsp; People</div>
                           </div>
                        </div>

                        <div className="card-action">
                           <Button onClick={() => gotoCompany(item)}>Explore </Button>
                        </div>
                     </div>
                  ))}
               </div>
            </>
         }
         {activeTab === 'ValueChain' &&
            <>
               <div className='value-chain-area value-chain-area-tab'>
                  <NodeLinkGraph applications={applications}
                     from={'new'}
                     applicationsCount={applicationsCount}
                     product={prod_info}
                     width={'100%'}
                  />
               </div>
            </>
         }
      </>
   )
}

export default IndustryValueChain
